import '../../Styles/ValuatorStyles/ValuatorAdminPanel.css';
import ValuatorNavbar from '../../components/ValuatorNavbar';
import { useEffect, useState } from 'react';
import {query, collection, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase-config';
import QuestionComponent from '../../components/CaseComponents/QuestionComponent';

function ValuatorAdminPanel() {
    const [companyID, setCompanyID] = useState("");
    const [selectedCompany, setSelectedCompany] = useState("m5");

    useEffect(() => {
        const fetchCompanyId = async () => {
          const q = query(
            collection(db, "companies"),
            where("company", "==", selectedCompany)
          );
          const querySnapshot = await getDocs(q);
          const companyDoc = querySnapshot.docs.find(doc => doc.data().company === selectedCompany);
            if(companyDoc.exists()) {
                setCompanyID(companyDoc.data().companyId)
            }
        }
        fetchCompanyId();
      }, [companyID]);

    return (
        <>
        <ValuatorNavbar />
        <div className="admin-page-container">
            <div className="admin-sub-container">
                <h1 className="main-header">Admin-Panel</h1>
                <QuestionComponent companyID={companyID} />
            </div>
        </div>
        </>
    )
}

export default ValuatorAdminPanel;